import {
  IResearchWorkItem,
  ResearchWorkTypeEnum,
} from "features/Research/types";
import { apiClient } from "lib/apiClient";

export interface IResearchDemandMetadataRequest {
  demandId: string;
  version: number;
  workType: ResearchWorkTypeEnum;
  dueDate: string;
}

export const updateResearchDemandMetadata = async ({
  demandId,
  version,
  workType,
  dueDate,
}: IResearchDemandMetadataRequest): Promise<IResearchWorkItem> => {
  const response = await apiClient.put(
    `/research/demands/${demandId}/metadata`,
    {
      version,
      workType,
      dueDate,
    }
  );
  return response.data;
};
